import { useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";
import { hasPermission } from "../../utils/permissionUtils";
import {
  Sliders,
  Users,
  Grid,
  CheckSquare,
  Map,
  GitBranch,
  Video,
} from "react-feather";

const useCalendarItems = () => {
  const { isAuthenticated, isInitialized, user } = useAuth();
  const [navItems, setNavItems] = useState([]);

  useEffect(() => {
    if (!isInitialized) return;

    if (!isAuthenticated) {
      setNavItems([]);
      return;
    }

    // Always show calendar-specific navigation regardless of user type
    const calendarNavItems = [
      {
        title: "Calendar",
        pages: [
          hasPermission("VIEW_CALENDAR") && {
            href: "dashboard",
            icon: Sliders,
            title: "Dashboard",
          },
          hasPermission("VIEW_EVENT_TYPES") && {
            href: "/calendar/event-types",
            icon: Users,
            title: "Event Types",
          },
          hasPermission("VIEW_BOOKINGS") && {
            href: "/calendar/bookings",
            icon: Grid,
            title: "Bookings",
          },
          hasPermission("VIEW_CALENDAR") && {
            href: "/calendar/meetings",
            icon: Video,
            title: "Meetings",
          },
          hasPermission("VIEW_AVAILABILITY") && {
            href: "/calendar/availability",
            icon: CheckSquare,
            title: "Availability",
          },
          hasPermission("MANAGE_TEAM_AVAILABILITY") && {
            href: "/calendar/teams",
            icon: Map,
            title: "Teams",
          },
          hasPermission("VIEW_CALENDAR") && {
            // Dynamic link with the current user's ID
            href: user?.name
              ? `/preview/events/u/${user.name
                  .toLowerCase()
                  .replace(/\s+/g, "-")}`
              : "/preview/events",
            icon: Map,
            title: "View Public Page",
            target: "_blank", // Open in new tab
            rel: "noopener noreferrer", // Security best practice for links opening in new tabs
          },
          hasPermission("VIEW_EVENT_TYPES") && {
            href: "/calendar/routing-forms",
            icon: GitBranch,
            title: "Routing Forms",
          },
        ].filter(Boolean),
      },
    ];

    setNavItems(calendarNavItems);
  }, [isInitialized, isAuthenticated, user]); // Dependencies are now stable

  return navItems;
};

export default useCalendarItems;
